<template>
  <div>
    <a class="course-card">
      <img src="@img/tag_live.png" class="tag" v-if="item.course_type == 1" alt>
      <div class="cover">
        <img :src="item.img_url?item.img_url:def" class="covers" alt>
        <img src="@img/living0.png" v-if="item.living == '0'" class="state" alt>
        <img src="@img/living1.png" v-if="item.living == '1'" class="state" alt>
        <img src="@img/living2.png" v-if="item.living == '2'" class="state" alt>
        <img src="@img/living3.png" v-if="item.living == '3'" class="state" alt>
        <img src="@img/living4.png" v-if="item.living == '4'" class="state" alt>
      </div>
      <div class="title">{{item.title}}</div>
      <div class="foot">
        <div class="views" v-show="item.viewer_num">
          <span><img src="@img/eye.png" alt>
          {{item.viewer_num}}</span>
        </div>
        <div :class="item.real_price==0?'free':'price'">{{item.on_public == 1 ? "免费" : "￥" + item.real_price / 100}}</div>
      </div>
    </a>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      def: require("@img/default_cover.png")
    };
  },
  computed: {
    ...mapState(["priceshow"]),
  },
  methods: {},
  props: ["item"]
};
</script>

<style lang="less" scoped>
.tag {
  position: absolute;
  z-index: 1000;
  left: 12px;
  width: 36px;
  height: 49px;
}
.course-card {
  position: relative;
    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #E5ECF4;
    width: 100%;
    height: 224px;
    /* padding: 12px; */
    -webkit-transition: 0.3s ease all;
    transition: 0.3s ease all;
    background: #fff;
    border-radius: 4px;
  &:hover {
    transform: translateY(-6px);
    -webkit-transform: translateY(-6px);
    -moz-transform: translateY(-6px);
    box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
    -webkit-box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
    -moz-box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
  }
  .cover {
    position: relative;
    .covers {
      width: 100%;
      height: 136px;
    }
    .state {
      position: absolute;
      width: 70px;
      z-index: 1000;
      right: 0;
      bottom: 0;
    }
  }
  .title {
        margin: 0 0 10px;
    text-align: justify;
    margin-top: 16px;
    margin-bottom: 12px;
    margin-left: 10px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .foot {
    display: flex;
    justify-content: space-between;
    height: 22px;
    line-height: 22px;
    font-size: 12px;
    color: #999;
    margin-left: 12px;
    .views {
      font-size: 12px;
      img {
        width: 14px;
        vertical-align: middle;
        margin-bottom: 4px;
      }
    }
    .price {
      color: #f5a623;
      margin-right: 12px;
    }
    .free {
      color: #0a9a3d;
      margin-right: 12px;
    }
  }
}
</style>
